// MINDESTBESTELLWERT
(() => {
  // === Einstellungen ===
  // Mindestbestellwert in Cent (z.B. 1900 = 19,00 €)
  const MIN_CENTS = 1500;
  const DISABLED_TEXT = "Mindestbestellwert 15 €";

  // === Basisstyles für Zustand & Hinweis ===
  const style = document.createElement("style");
  style.textContent = `
    .min-order-disabled {
      opacity: .5 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
    }
    .min-order-note {
      font-size: 1.1rem;
      margin-top: 0.75rem;
      opacity: 1 !important;
      text-align:center;
      color: inherit; /* gleiche Farbe wie Umgebung, nicht ausgegraut */
    }
    .min-order-note .min-order-amount,
    .min-order-note .min-order-label {
      font-weight: 700;
    }
  `;
  document.head.appendChild(style);

  // === Helper ===
  const formatEUR = (cents) => {
    const val = (cents / 100).toFixed(2);
    return val.replace(".", ",") + " €";
  };

  const getCheckoutButtons = () =>
    Array.from(document.querySelectorAll('button[name="checkout"]'));

  const fetchCartTotal = async () => {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) throw new Error("cart.js fetch failed");
      const cart = await res.json();
      return cart.total_price ?? 0; // in Cent
    } catch (e) {
      console.warn("[min-order] Konnte /cart.js nicht laden:", e);
      return 0;
    }
  };

  const disableBtn = (btn) => {
    if (!btn.dataset.originalText) {
      // Original-HTML sichern (Icon + Text + evtl. Betrag)
      btn.dataset.originalText = btn.innerHTML.trim();
    }
    btn.classList.add("min-order-disabled");
    btn.setAttribute("aria-disabled", "true");
    btn.setAttribute("disabled", "disabled");
    btn.textContent = DISABLED_TEXT;

    if (!btn._minOrderClickBound) {
      btn.addEventListener("click", (ev) => {
        if (btn.classList.contains("min-order-disabled")) {
          ev.preventDefault();
          ev.stopPropagation();
        }
      });
      btn._minOrderClickBound = true;
    }
  };

  const enableBtn = (btn) => {
    btn.classList.remove("min-order-disabled");
    btn.removeAttribute("aria-disabled");
    btn.removeAttribute("disabled");
    if (btn.dataset.originalText) {
      btn.innerHTML = btn.dataset.originalText;
    }
  };

  // Sucht den passenden Bereich für den Hinweis (oben im Drawer oder Cart-Footer)
  const findSummaryContainer = () => {
    // 1) Preferierter Bereich: obere Summary-Leiste im Drawer
    const topSummary = document.querySelector(".cart-drawer__summary--top");
    if (topSummary) return topSummary;

    // 2) Fallback: generische Summary im Drawer
    const anySummary = document.querySelector(".cart-drawer__summary");
    if (anySummary) return anySummary;

    // 3) Warenkorb-Seite: Cart-Footer
    const cartFooter = document.querySelector(".cart__footer");
    if (cartFooter) return cartFooter;

    return null;
  };

  const ensureNoteElement = () => {
    const summary = findSummaryContainer();
    if (!summary) return null;

    let note = summary.querySelector(".min-order-note");
    if (!note) {
      note = document.createElement("p");
      note.className = "min-order-note";

      // Nähe zum Checkout-Button:
      const checkoutWrapper = summary.querySelector(".cart-drawer__checkout-buttons");
      if (checkoutWrapper) {
        // Hinweis UNTER dem Button einfügen
        checkoutWrapper.insertAdjacentElement("afterend", note);
      } else {
        // Fallback: am Ende des Summary-Blocks
        summary.appendChild(note);
      }
    }
    return note;
  };

  const renderNote = (isBelowMin, totalCents) => {
    const summary = findSummaryContainer();
    if (!summary) return;

    let note = summary.querySelector(".min-order-note");

    if (isBelowMin) {
      if (!note) {
        note = ensureNoteElement();
      }
      if (!note) return;

      const diff = MIN_CENTS - totalCents;
      note.innerHTML =
        `Noch <span class="min-order-amount">${formatEUR(diff)}</span> ` +
        `bis zum <span class="min-order-label">Mindestbestellwert</span> von ${formatEUR(MIN_CENTS)}.`;
    } else if (note) {
      note.remove();
    }
  };

  const applyStateToAll = (isBelowMin, totalCents) => {
    const buttons = getCheckoutButtons();
    buttons.forEach((btn) => (isBelowMin ? disableBtn(btn) : enableBtn(btn)));
    renderNote(isBelowMin, totalCents);
  };

  let lastTotal = null;
  let lastBelow = null;

  const evaluate = async () => {
    const total = await fetchCartTotal();
    const below = total < MIN_CENTS;
    if (total === lastTotal && below === lastBelow) return;
    lastTotal = total;
    lastBelow = below;
    applyStateToAll(below, total);
  };

  const wireListeners = () => {
    // Theme-eigene Events, falls vorhanden
    document.addEventListener("cart:updated", evaluate, { passive: true });
    document.addEventListener("cart:refresh", evaluate, { passive: true });

    // MutationObserver auf den Drawer (Mengenänderungen, Items löschen etc.)
    const drawer = document.querySelector("cart-drawer, #cart-drawer");
    if (drawer) {
      const mo = new MutationObserver(() => {
        clearTimeout(drawer._minOrderTO);
        drawer._minOrderTO = setTimeout(evaluate, 120);
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }

    // Form-Submits blocken, solange unter Mindestbestellwert
    const cartForms = Array.from(
      document.querySelectorAll('form[action="/cart"], #cart-drawer-form, form[action="/cart"]')
    );
    cartForms.forEach((form) => {
      if (form._minOrderSubmitBound) return;
      form.addEventListener("submit", (ev) => {
        if (typeof lastTotal === "number" && lastTotal < MIN_CENTS) {
          ev.preventDefault();
          ev.stopPropagation();
          evaluate();
        }
      });
      form._minOrderSubmitBound = true;
    });
  };

  const onReady = () => {
    wireListeners();
    evaluate();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();